/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Support_Title_2Inputs */

const en_wb_support_title_2 = /** @type {(inputs: Wb_Support_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The answer’s already prepared.`)
};

const lv_wb_support_title_2 = /** @type {(inputs: Wb_Support_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atbilde jau ir sagatavota.`)
};

/**
* | output |
* | --- |
* | "The answer’s already prepared." |
*
* @param {Wb_Support_Title_2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_support_title_2 = /** @type {((inputs?: Wb_Support_Title_2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Support_Title_2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_support_title_2(inputs)
	return en_wb_support_title_2(inputs)
});